import { render, staticRenderFns } from "./SchoolListsGradeIndex.vue?vue&type=template&id=a1be0d24"
import script from "./SchoolListsGradeIndex.vue?vue&type=script&lang=js"
export * from "./SchoolListsGradeIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports